module.exports = __webpack_public_path__ + "img/9788952214393.dab6a6ca.jpg";